// @flow

const test = () => {
  if (typeof window === 'undefined' || window.matchMedia == null) {
    return null;
  }
  return !window.matchMedia('(hover: none)').matches;
};

export const supportsHover: ?boolean = test();
